




import Parts from '@/components/products/parts/Parts.vue'
import AttributeLabelsModule, { AttributeLabel } from '@/store/AttributeLabelsModule'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: { Parts }
})
export default class Czesci extends Vue {
  get pageId() {
    return parseInt(this.$route.params.pageId)
  }

  created() {
    this.initLabels()
  }

  private async initLabels() {
    const productDetailsDefs = this.$store.getModule(AttributeLabelsModule)
    if (Object.keys(productDetailsDefs.labels).length === 0) {
      const { data } = await this.$axios.get<AttributeLabel[]>('attribute-labels')
      this.$store.initLabels(data)
    }
  }
}
